export default __webpack_public_path__ + "static/media/Fantasy_02.66180b16.png";